import React from 'react';
import { Link } from 'react-router-dom';
import PageShell from '../Components/ui/PageShell';

function SettingsHub() {
  return (
    <PageShell
      title="Settings"
      subtitle="Manage your profile and account preferences."
      breadcrumbs={[
        { label: 'Dashboard', path: '/dashboard' },
        { label: 'Settings' },
      ]}
      backTo="/dashboard"
    >
      <div className="hr-dashboard-grid">
        <Link to="/Profile" className="hr-dashboard-card">
          <h3>Profile</h3>
          <p>View and edit your employee details</p>
        </Link>
        <Link to="/settings/change-password" className="hr-dashboard-card">
          <h3>Change Password</h3>
          <p>Update your account password</p>
        </Link>
      </div>
    </PageShell>
  );
}

export default SettingsHub;
